import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import StyledTableCell from "app/Components/Tables/StyledTableCell";

export default function PlayerSessionsHeader() {
  return (
    <TableHead>
      <TableRow>
        <StyledTableCell align="center">Player Name</StyledTableCell>
        <StyledTableCell align="center">Game Name</StyledTableCell>
        <StyledTableCell align="center">Start Time</StyledTableCell>
        <StyledTableCell align="center">End Time</StyledTableCell>
        <StyledTableCell align="center">Total Time Running</StyledTableCell>
      </TableRow>
    </TableHead>
  );
}
